import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import Tinymce from './Tinymce'
import { documentFormSubmit, deleteDocument } from '../actions'
import history from '../history'

class DocumentForm extends Component {
  componentWillMount() {
    const { documents, initialize, user, match, setHeader } = this.props
    if(!user.admin){
      history.push('/document')
    }

    const newDocument = !(match.params.id && documents[match.params.id])
    const docId = newDocument? null : match.params.id
    const title = newDocument? "" : documents[match.params.id].title
    const text = newDocument? "" : documents[match.params.id].text
    initialize({ 
      uid: user.uid,
      docId,
      title,
      text
    })

    const header = newDocument? {
      title: "新規ドキュメント",
      left: {
        text: 'back',
        url: "/document"
      },
      right: null
    } : {
      title: null,
      left: {
        text: 'back',
        url: "/document/" + docId
      },
      right: null
    }
    setHeader(header)
  }
  render() {
    const { documentFormSubmit, handleSubmit, change, documents, match, deleteDocument } = this.props
    const newDocument = !(match.params.id && documents[match.params.id])
    const docId = newDocument? null : match.params.id
    const initialValue = newDocument? "" : documents[docId].text
    return (
      <div>
        <form onSubmit={handleSubmit(values => documentFormSubmit(values))} >
          <Field name="docId" component="input" type="hidden"/>
          <Field name="uid" component="input" type="hidden"/>
          <Field name="text" component="input" type="hidden" />
          <div className="field">
            <div className="control">
              <Field name="title" component="input" className="input is-large" placeholder="タイトル" />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <Tinymce
                init={{ 
                  height: 400,
                  plugins: 'table link autolink hr code toc', 
                  toolbar: 'formatselect styleselect bold hr removeformat | link unlink | table | toc | code ',
                  block_formats: '文章=p;見出し=h2',
                  style_formats: [
                    { title: '■ Red', inline: 'span', styles: { color: '#f00' } }
                  ]
                }}
                initialValue={initialValue}
                onChange={ e => { change('text',  e.target.getContent()) } }
              />
            </div>
          </div>
          <div className="is-clearfix">
            {newDocument?
              null
            :
              <button type="button" className="button is-white" onClick={ () => window.confirm('削除してよろしいですか？')? deleteDocument(docId) : null }><i className="far fa-trash-alt"></i></button>
            }
            <button type="submit" className="button is-pulled-right">保 存</button>
          </div>
        </form>
      </div>
    )
  }
}
export default connect(
  state => ({ user: state.user }),
  { documentFormSubmit, deleteDocument }
)(reduxForm({ form: 'document' })(withRouter(DocumentForm)))



// WEBPACK FOOTER //
// ./src/components/DocumentForm.js